import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { toast } from 'react-toastify'

// Components
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import Loading from '../../components/Loading';
import Modal from '../../components/Modal';
import {GoogleLogin} from 'react-google-login';

// Util
import Public from '../../util/public';
import config from '../../enviroment/config.json';

function Layout({onLogin, onGoogleLogin, onSignUp, formType, setFormType, onForgotPassword, onForgotLogin, loading, message, closeMessageModal, loadingSessionRemake}) {
  const classes = useStyles();
  // Login
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);

  // Register
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerLogin, setRegisterLogin] = useState("");
  const [registerName, setRegisterName] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerPasswordConfirm, setRegisterPasswordConfirm] = useState("");
  
  // Forgot password
  const [forgotEmail, setForgotEmail] = useState("");

  useEffect(() => {
    document.title = "Login - Easy Scrum"
  }, [])

  return (
    <>
      {loadingSessionRemake && <Loading className={classes.loading}></Loading>}
      {!loadingSessionRemake && (
        <div className={classes.bg}>
          <h1 style={{display: 'none'}}>Login - Easy Scrum</h1>
          <>
          <form style={formType == "LOGIN" ? {} : {display: 'none'}} id={"login-form"} className={classes.form} onSubmit={(e) => {e.preventDefault(); onLogin(login, password, remember)}}>
            <h2>Account Login</h2>
            <TextInput  id={"login-login"} name={"login-login"} value={login}  label="Login" onInput={setLogin}></TextInput>
            <TextInput  id={"login-password"} name={"login-password"} value={password} type={'password'} onInput={setPassword} label="Password"></TextInput>
            <label htmlFor={"login-remember"} className={classes.remember}>
              Remember Access
              <TextInput type={"checkbox"} id={"login-remember"} onInput={() => setRemember(!remember)}></TextInput>
            </label>
            Forgot <a onClick={() => setFormType('FORGOT-LOGIN')}>Login</a> | <a onClick={() => setFormType('FORGOT-PASSWORD')}>Password</a>

            <Button type="submit" disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : "LOGIN"}</Button>
            <GoogleLogin
              className={classes.googleBtn}
              clientId={config.google.client_id}
              buttonText={"Login with google"}
              onSuccess={(googleSuccess) => {
                onGoogleLogin(googleSuccess);
              }}
              onFailure={(googleFailure) => {
                console.error("Google failure", googleFailure);
                // toast.error("Gmail login error");
                
              }}
              isSignedIn={false}
              cookiePolicy={"single_host_origin"}
            />
            <div className={classes.otheropt}>
              Don't have an account?
              <a onClick={() => setFormType('SIGNUP')}>Sign Up</a>
              </div>
          </form>
          
          <form style={formType == "SIGNUP" ? {} : {display: 'none'}} id={"register-form"} className={classes.form} onSubmit={(e) => {e.preventDefault(); onSignUp(registerEmail, registerLogin, registerName, registerPassword, registerPasswordConfirm)}}>
            <h2>Account Sign Up</h2>
            <TextInput  id={"register-name"} name={"register-name"} value={registerName} label="Name" onInput={setRegisterName}></TextInput>
            <TextInput  id={"register-email"} name={"register-email"} value={registerEmail} type={'email'} onInput={setRegisterEmail} label="E-mail"></TextInput>
            <TextInput  id={"register-login"} name={"register-login"} value={registerLogin} label="Login" onInput={setRegisterLogin}></TextInput>
            <TextInput  id={"register-password"} name={"register-password"} value={registerPassword} type={'password'} onInput={setRegisterPassword} label="Password"></TextInput>
            <TextInput  id={"register-password-confirm"} name={"register-password-confirm"} value={registerPasswordConfirm} type={'password'} onInput={setRegisterPasswordConfirm} label="Confirm Password"></TextInput>
            <Button type="submit" disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : "SIGN UP"}</Button>
            <div className={classes.otheropt}>
              Already have an account?
              <a onClick={() => setFormType('LOGIN')}>Login</a>
              </div>
          </form>

          <form style={formType == "FORGOT-PASSWORD" ? {} : {display: 'none'}} className={classes.form} onSubmit={(e) => {e.preventDefault(); onForgotPassword(forgotEmail)}}>
            <h2>Forgot your password?</h2>
            <TextInput value={forgotEmail} type={'email'} onInput={setForgotEmail} label="E-mail"></TextInput>
            <Button type="submit" disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : "RESET PASSWORD"}</Button>
            <div className={classes.otheropt}>
              Already have an account?
              <a onClick={() => setFormType('LOGIN')}>Login</a>
              </div>
          </form>

          <form style={formType == "FORGOT-LOGIN" ? {} : {display: 'none'}} className={classes.form} onSubmit={(e) => {e.preventDefault(); onForgotLogin(forgotEmail);}}>
            <h2>Forgot your login?</h2>
            <TextInput value={forgotEmail} type={'email'} onInput={setForgotEmail} label="E-mail"></TextInput>
            <Button type="submit" disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : "SEND"}</Button>
            <div className={classes.otheropt}>
              Already have an account?
              <a onClick={() => setFormType('LOGIN')}>Login</a>
              </div>
          </form>
          </>
          

          <img className={classes.logo} src={Public("icons/white-icon.png")} alt="Easy Scrum Logo"></img>
        </div>   
      )}
      

          <Modal onCancel={closeMessageModal} visible={message !== null} title={"Alert"} submitText={"Ok"} cancelText={false} onSubmit={closeMessageModal}>
            {message}
          </Modal>
    </>
  );
}

export default Layout;